const button = {
    cancel: 'Abbrechen',
    ok: 'Ja'
}

export default button